import React from 'react';
import { motion } from 'framer-motion';
export function ResultsSection() {
  const results = [{
    image: 'https://cdn.magicpatterns.com/uploads/3Xs5bXRxMNUhTrnbyRSubj/Transformacion_de_la_piel_de_Carey.png',
    alt: 'Transformación de la piel de Carey'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/kVoYEddfLsMMpVqB9CLWza/Transformacion_de_piel_en_90_dias.png',
    alt: 'Transformación de piel en 90 días'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/ioGttVyH7mzy7EmNXwXm96/Progreso_en_90_dias_de_cuidado.png',
    alt: 'Progreso en 90 días de cuidado'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/e7JvtjCX4QQrsHa4huVUYG/Transformacion_de_piel_en_comparacion.png',
    alt: 'Transformación de piel en comparación'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/fNuwPubajR2saxiobVHUGC/Transformacion_de_piel_en_tres_semanas.png',
    alt: 'Transformación de piel en tres semanas'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/4m7sYNEvAURVsP9AZMMQRF/Transformacion_despues_de_90_dias_de_uso.png',
    alt: 'Transformación después de 90 días de uso'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/cwDjEFQgtgtSN8mdRtntPu/Transformacion_facial_con_tratamiento_de_skincare.png',
    alt: 'Transformación facial con tratamiento de skincare'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-188" data-mp="fej5ik5vzobg">
      <div className="container mx-auto px-6 md:px-12" data-id="element-189" data-mp="ah9h97u8hip7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-190" data-mp="ajvot7h4jy7f">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-191" data-mp="1uxcu7bveckzu">
            Resultados reales de mujeres reales ✨
          </h2>
          <p className="text-brand-charcoal/70" data-id="element-192" data-mp="3pct2w89uxtzn">
            Sin filtros. Sin photoshop. Solo piel transformándose 🌱
          </p>
        </motion.div>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-193" data-mp="3fff0hckrr5qc">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-4 rounded-2xl shadow-sm w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]" data-id="element-194" data-mp="3ke8cf0keqooe" data-mpi={index}>
              <div className="w-full rounded-lg overflow-hidden relative" data-id="element-195" data-mp="2nmxtuok7xm69">
                <img src={result.image} alt={result.alt} className="w-full h-auto object-cover" data-id="element-196" data-mp="2rqlxwx9n5zmr" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}